import React from 'react';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg 
      viewBox="0 0 728 880" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      <path 
        d="M618.412 263.871C651.891 313.121 671.454 372.592 671.454 436.629C671.454 606.562 533.696 744.325 363.762 744.325C193.829 744.325 56.07 606.563 56.07 436.629C56.07 266.696 193.828 128.937 363.762 128.937C441.595 128.937 512.683 157.841 566.87 205.495" 
        stroke="currentColor" 
        strokeWidth="24"
        strokeLinecap="round"
      />
      <circle cx="596.34" cy="231.868" r="25" fill="currentColor" />
      <path 
        d="M363.763 822.932L363.763 56.069" 
        stroke="currentColor" 
        strokeWidth="24" 
      />
      <path 
        d="M363.763 744.323C255.842 711.065 175.855 580.919 175.855 436.631C175.855 293.193 256.809 163.031 363.763 128.939" 
        stroke="currentColor" 
        strokeWidth="24" 
        strokeLinecap="butt"
      />
    </svg>
  );
};